import React, {Component} from 'react'
import {ContactStyle, Form} from './../../../styles'
import {fetchPage, addContact} from './../../../services/ApiController'
import {Field, Button, Success, Textarea, Error} from './../../../components'
import { withLoader } from '../../../hoc/withLoader';

const REGEX_MAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

class Contact extends Component {
  state = {
    ready: true,
    error: '',
    fields: {
      email: {
        label: 'Email'
      },
      firstName: {
        label: 'First Name'
      },
      lastName: {
        label: 'Last Name'
      },
      subject: {
        label: 'Subject'
      },
      message: {
        label: 'Message',
        type: 'textearea',
      },
      _token: {
        label: 'token'
      },
    },
    action: '',
    form: {},
    clean: false,
  }

  componentWillReceiveProps({ data }) {
    if (data !== this.props.data) {
      this.setState({
        fields: {
          email: {
            label: 'Email',
            ...data.fields.email
          },
          firstName: {
            label: 'First Name',
            ...data.fields.firstName
          },
          lastName: {
            label: 'Last Name',
            ...data.fields.lastName
          },
          subject: {
            label: 'Subject',
            ...data.fields.subject
          },
          _token: {
            label: 'token',
            ...data.fields['_token']
          },
        },
        message: {
          label: 'Message',
          ...data.fields.message
        },
        action: data.action,
        form: {},
      })

      const row = []
      row[data.fields['_token'].name] = data.fields['_token'].value
      this.setState({ form: row })
    }
  }

  addFormData = (data) => {
    const { form } = this.state
    const row = []
    row[data.key] = data.value
    this.setState({ form: { ...form, ...row} })
  }

  handlerSubmit = async () => {
    console.log(this.state.action)
    this.setState({
      error: ''
    }, () => {
      if (this.check().valid ) {
        addContact(this.state.action, this.state.form).then((data) => {
          if (data.success) { 
            this.setState({ form: {}, clean: true})
            this.setState({ success: 'Thank you for contacting us. We have received your enquiry and will respond to you'})
          }
        }).then(() => {
          this.setState({ clean: false })
        }).catch((e) => {
          console.log('Something wrong with postMessage')
        })
      } else {
        this.setState({
          error: this.check().err
        })
      }
    })
  }

  check = () => {
    let valid = true
    let err = ''
    
    if (Object.keys(this.state.form).length < 6) {
      err = 'All fields are required'
      valid = false
    } else {
      Object.keys(this.state.form).map((row) => {
        if (this.state.form[row] === '') {
          valid = false
          err = 'All fields are required'
        }
      })
    }
    
    if (this.state.form['contact[email]']) {
      if (!this.isMail(this.state.form['contact[email]'])) {
        err = 'Email is not valid.'
        valid = false
      }
    }
    
    return {valid, err}
  }

  isMail = (val) => {
    return REGEX_MAIL.test(val.toLowerCase())
  }

  render () {
    const { fields, success, ready, message, error } = this.state
    const { isReady } = this.props

    return (
      <div className={` contact ${ContactStyle(ready)}`}>
        <div className='page-inner'>
          <div className='contact-title title'>
            Contact
          </div>
          <form className={`contact-form ${Form} transition ${isReady ? 'transition--ready' : ''}`} onSubmit={this.handlerSubmit}>
            {
              Object.keys(fields).map((field, index) => (
                <Field clean={this.state.clean} onChange={this.addFormData} {...fields[field]} key={field}> {fields[field].label} </Field>
              ))
            }
            {
              message && <Textarea clean={this.state.clean} onChange={this.addFormData} {...message}> {message.label} </Textarea>
            }
            <div className="contact-btn-submit">
              <Button theme="red" type="submit" onCallback={this.handlerSubmit}> Send </Button>
            </div>
            {
              error !== '' && (
                <Error className="error"> {error} </Error>
              )
            }
            {
              error === '' && success && (
                <Success className="success"> {success} </Success>
              )
            }
          </form>
        </div>
      </div>
    )
  }
}

export default withLoader(Contact)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Contact.js